// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
import queryString from "query-string";
import { HttpResult } from "../http";
import ProjectPreview from "../../model/ProjectPreview";

const BASE_URI = "/projects";

export default {
  /**
   * Searches projects on the backend server
   * @param searchText
   */
  search(searchText: string): Promise<HttpResult<{ items: ProjectPreview[]; hasMore: boolean }>> {
    const filter = {
      searchText: searchText,
      offset: 0,
      limit: 20,
    };
    const url = BASE_URI + "/search?" + queryString.stringify(filter);
    return backend.get(url);
  },
};
